function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Layout, Menu } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import { PersonFillLock, TicketPerforatedFill, CashStack, CalendarEventFill, BuildingsFill } from 'react-bootstrap-icons';
import { Link, Outlet } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useOutletContext } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.min.js';
import Common from "../components/includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Header = Layout.Header,
  Sider = Layout.Sider,
  Content = Layout.Content;
var MyAccount = function MyAccount(_ref) {
  var _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? 'mtickets' : _ref$selected;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var _useState3 = useState(localStorage.getItem("currentAccountMenuKey") == null ? selected : localStorage.getItem("currentAccountMenuKey")),
    _useState4 = _slicedToArray(_useState3, 2),
    current = _useState4[0],
    setCurrent = _useState4[1];
  var _useOutletContext = useOutletContext(),
    handleNewTicket = _useOutletContext.handleNewTicket;
  var _useOutletContext2 = useOutletContext(),
    handleShowEventDetails = _useOutletContext2.handleShowEventDetails;
  var toggle = function toggle() {
    collapsed ? setCollapsed(false) : setCollapsed(true);
  };
  var handleMenuChange = function handleMenuChange(e) {
    setCurrent(e.key);
    localStorage.setItem("currentAccountMenuKey", e.key);
  };
  useEffect(function () {
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).id : null
    }).then(function (response) {
      if (response.data.auth == true) {
        localStorage.setItem('userData', JSON.stringify(response.data.user));
      } else {
        localStorage.removeItem('userData');
        localStorage.removeItem('isOn');
        window.location = '/';
      }
    });
  }, []);
  useEffect(function () {
    document.title = 'Mon compte';
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "page-container",
      children: /*#__PURE__*/_jsx(Layout, {
        children: /*#__PURE__*/_jsx(Layout, {
          className: "site-layout",
          children: /*#__PURE__*/_jsxs(Content, {
            className: "page-container",
            style: {
              margin: '7px 8px',
              padding: 14,
              minHeight: 280,
              marginTop: "50px"
            },
            children: [/*#__PURE__*/_jsx(Container, {
              children: /*#__PURE__*/_jsx(Row, {
                children: /*#__PURE__*/_jsx(Col, {
                  lg: 10,
                  children: /*#__PURE__*/_jsx("div", {
                    className: "account-menu-wrapper",
                    children: /*#__PURE__*/_jsxs(Menu, {
                      theme: "light",
                      onClick: handleMenuChange,
                      mode: "horizontal",
                      className: "account-menu-wrapper",
                      selectedKeys: current,
                      children: [/*#__PURE__*/_jsx(Menu.Item, {
                        icon: /*#__PURE__*/_jsx(CalendarEventFill, {
                          size: 20
                        }),
                        children: /*#__PURE__*/_jsx(Link, {
                          to: "/home/compte/m-events",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "Console Ev\xE8nements"
                          })
                        })
                      }, "mevents"), /*#__PURE__*/_jsx(Menu.Item, {
                        icon: /*#__PURE__*/_jsx(BuildingsFill, {
                          size: 20
                        }),
                        children: /*#__PURE__*/_jsx(Link, {
                          to: "/home/compte/m-organization",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "Ma Structure"
                          })
                        })
                      }, 'org'), /*#__PURE__*/_jsx(Menu.Item, {
                        icon: /*#__PURE__*/_jsx(TicketPerforatedFill, {
                          size: 20
                        }),
                        children: /*#__PURE__*/_jsx(Link, {
                          to: "/home/compte/m-tickets",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "Mes Tickets"
                          })
                        })
                      }, "mtickets"), /*#__PURE__*/_jsx(Menu.Item, {
                        icon: /*#__PURE__*/_jsx(CashStack, {
                          size: 20
                        }),
                        children: /*#__PURE__*/_jsx(Link, {
                          to: "/home/compte/m-payments",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "Mes Paiements"
                          })
                        })
                      }, "m-payments"), /*#__PURE__*/_jsx(Menu.Item, {
                        icon: /*#__PURE__*/_jsx(PersonFillLock, {
                          size: 20
                        }),
                        children: /*#__PURE__*/_jsx(Link, {
                          to: "/home/compte/profil",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "Mon Compte"
                          })
                        })
                      }, "acc")]
                    })
                  })
                })
              })
            }), /*#__PURE__*/_jsx(Outlet, {
              context: {
                handleNewTicket: handleNewTicket,
                handleShowEventDetails: handleShowEventDetails
              }
            })]
          })
        })
      })
    })
  });
};
export default MyAccount;